import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faElevator, 
  faArrowsAltV, 
  faUniversalAccess, 
  faBuilding,
  faTools,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const FoerdertechnikPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faElevator} />
            </div>
            <h1>Fördertechnik</h1>
            <p>
              Professionelle Planung von Aufzugsanlagen und Fördertechnik für optimale Mobilität
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Fachplanung für Fördertechnik</h2>
            <p>
              Das Ingenieurbüro Neubaur bietet umfassende Planungsleistungen im Bereich Fördertechnik. 
              Wir planen Aufzugsanlagen und Fördersysteme für Neubauten und Bestandsgebäude unter Berücksichtigung 
              aller technischen, wirtschaftlichen und gesetzlichen Anforderungen.
            </p>
            <p>
              Unsere Planungen zeichnen sich durch hohe Funktionalität, Zuverlässigkeit und Energieeffizienz aus. 
              Wir legen besonderen Wert auf Barrierefreiheit und Nutzerfreundlichkeit.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Fördertechnik</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faElevator} />
                </div>
                <h3 className="service-feature-title">Aufzugsanlagen</h3>
                <p className="service-feature-text">
                  Planung von Personen- und Lastenaufzügen für verschiedenste Gebäudetypen und Anforderungen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faUniversalAccess} />
                </div>
                <h3 className="service-feature-title">Barrierefreie Erschließung</h3>
                <p className="service-feature-text">
                  Konzeption barrierefreier Zugänge und Erschließungssysteme gemäß aktueller Normen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faArrowsAltV} />
                </div>
                <h3 className="service-feature-title">Spezialaufzüge</h3>
                <p className="service-feature-text">
                  Planung von Sonderanfertigungen wie Panoramaaufzügen, Autoaufzügen oder Bühnenliften.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faBuilding} />
                </div>
                <h3 className="service-feature-title">Modernisierung</h3>
                <p className="service-feature-text">
                  Konzepte zur Modernisierung bestehender Aufzugsanlagen und Fördersysteme.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faTools} />
                </div>
                <h3 className="service-feature-title">Wartungskonzepte</h3>
                <p className="service-feature-text">
                  Erstellung von Wartungs- und Instandhaltungskonzepten für Fördertechnik.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <h3 className="service-feature-title">Sicherheitstechnik</h3>
                <p className="service-feature-text">
                  Integration von Sicherheitssystemen und Notruftechnik in Aufzugsanlagen.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Bedarfsanalyse</h3>
                  <p className="process-text">
                    Wir ermitteln Ihren spezifischen Bedarf und die Anforderungen an die Fördertechnik.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Konzeptentwicklung</h3>
                  <p className="process-text">
                    Basierend auf der Analyse entwickeln wir ein maßgeschneidertes Förderkonzept.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte technische Planungen für alle fördertechnischen Anlagen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Ausschreibung und Vergabe</h3>
                  <p className="process-text">
                    Wir unterstützen bei der Ausschreibung und Vergabe der Leistungen an qualifizierte Unternehmen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Bauphase überwachen wir die fachgerechte Installation der Fördertechnik.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Abnahme und Dokumentation</h3>
                  <p className="process-text">
                    Wir begleiten die Abnahme der Anlagen und erstellen die erforderliche Dokumentation.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Optimale Mobilität für Ihr Gebäude</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich Fördertechnik für Ihr nächstes Bauprojekt oder die Modernisierung 
              bestehender Anlagen. Wir beraten Sie gerne zu allen Fragen rund um Aufzüge und Fördersysteme.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default FoerdertechnikPage;
